import { Component, OnInit, OnDestroy } from '@angular/core';
import { Subscription } from 'rxjs';

import { FileProvider } from '@classes/file/file-provider';
import { FileService } from '@services/file.service';
import { UiService } from '@services/ui.service';
import { FileInfo } from '@classes/file/file-info';
import { FileImport } from '@classes/file/file-import';
import { FileSource } from '@enums/file-source.enum';
import { AuthService } from '@services/auth.service';
import { LicenceRoleType } from '@enums/licence-role-type.enum';

@Component({
    selector: 'app-upload-provider',
    templateUrl: './upload-provider.component.html',
    styleUrls: ['./upload-provider.component.scss']
})
export class UploadProviderComponent implements OnInit, OnDestroy {
    private loadingSub: Subscription;

    providers: FileProvider[];
    isLoading: boolean;
    selProvider: FileProvider;
    isClientImport: boolean;
    canImportClient: boolean;

    constructor(
        private fileSrv: FileService,
        private uiSrv: UiService,
        private authSrv: AuthService
    ) { }

    ngOnInit() {
        this.initSubscriptions();
        this.canImportClient = this.authSrv.isAuthorized([LicenceRoleType.bzd, LicenceRoleType.bko]);
    }

    sendFilesInfo(filesInfo: FileInfo[]): void {
        const fileTypeCode = this.selProvider.selFileType ? this.selProvider.selFileType.code : null;
        const fileImport = new FileImport(
            FileSource.provider,
            filesInfo,
            this.canImportClient ? this.isClientImport : false,
            {
                provider: this.selProvider.code,
                fileType: fileTypeCode
            }
        );

        this.fileSrv.import(fileImport)
            .subscribe(() => {
                this.fileSrv.getFiles().subscribe();
            });
    }

    private initSubscriptions(): void {
        this.isLoading = true;
        this.fileSrv.getFilesProviders()
            .subscribe(providersFromSrv => {
                this.providers = providersFromSrv;
                // Auto select first provider
                this.selProvider = this.providers[0];
                if (this.selProvider.fileTypes && this.selProvider.fileTypes.length === 1) {
                    this.selProvider.selFileType = this.selProvider.fileTypes[0];
                }
                this.isLoading = false;
            });

        this.loadingSub = this.uiSrv.loadingStateChanged
            .subscribe(loadingState => {
                this.isLoading = loadingState;
            });
    }

    ngOnDestroy(): void {
        if (this.loadingSub) {
            this.loadingSub.unsubscribe();
        }
    }
}
